import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Collapse, Row } from 'reactstrap';
import { kebabCase } from 'lodash';
import Icon from '../common/containers/icon';
import HeaderBar from './components/headerBar';
import Label from './components/label';
import entityComposition from '../common/classes/entityComposition';
import { labelSelector, styleSelector } from './selectors';
const Container = _ref => {
  let formatType = _ref.formatType,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$collapsible = _ref.collapsible,
    collapsible = _ref$collapsible === void 0 ? false : _ref$collapsible,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$startOpen = _ref.startOpen,
    startOpen = _ref$startOpen === void 0 ? false : _ref$startOpen,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? null : _ref$style;
  const _useState = useState(startOpen),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  const toggle = () => setOpen(!open);
  const testid = "container-".concat(kebabCase(label || ''));
  if (collapsible) {
    const collapseStyle = {
      textAlign: 'left',
      whiteSpace: 'pre-wrap',
      padding: '10px',
      position: 'relative',
      top: '0px'
    };
    const glyph = open ? 'caret-down fa-2x' : 'caret-right fa-2x';
    return /*#__PURE__*/React.createElement(Col, {
      className: "collapsible-header container",
      "data-testid": testid,
      style: style
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: toggle,
      onKeyPress: toggle,
      style: {
        width: '100%'
      },
      color: "link",
      className: "t-cheader tqc-control"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        float: 'left',
        width: '30px'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      style: {
        position: 'relative',
        top: 10
      },
      glyph: glyph
    })), /*#__PURE__*/React.createElement("div", {
      style: collapseStyle
    }, /*#__PURE__*/React.createElement("h3", {
      className: "".concat(className, "-").concat(open ? 'open' : 'closed')
    }, label))), /*#__PURE__*/React.createElement(Collapse, {
      isOpen: open
    }, children));
  }
  // for v1 subsection
  if (formatType === 'subsection') {
    // console.log(`value ${JSON.stringify(label, null, 2)}`);
    return /*#__PURE__*/React.createElement(Col, {
      "data-testid": testid,
      className: "container t-subsection-".concat(kebabCase(label)),
      style: style
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(HeaderBar, {
      className: "col-md-12",
      value: label
    }), children));
  }
  return /*#__PURE__*/React.createElement(Col, {
    className: testid,
    "data-testid": testid,
    style: style
  }, label !== undefined ? /*#__PURE__*/React.createElement(Label, {
    value: label
  }) : null, /*#__PURE__*/React.createElement(Row, null, children));
};
Container.propTypes = {
  className: PropTypes.string,
  formatType: PropTypes.string.isRequired,
  children: PropTypes.node,
  collapsible: PropTypes.bool,
  startOpen: PropTypes.bool,
  label: PropTypes.string,
  style: PropTypes.shape({})
};
export { Container as UncomposedContainer };
export default entityComposition(Container, [], {
  label: labelSelector,
  style: styleSelector
});